export default __webpack_public_path__ + "static/media/bell.efbee175.ogg";